const FAVORITES_KEY = 'ttymm_favorites';
const HISTORY_KEY = 'ttymm_history';

export interface HistoryEntry {
  id: string;
  viewedAt: number;
}

export function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string') : [];
  } catch {
    return [];
  }
}

export function writeFavorites(ids: string[]) {
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(ids));
  } catch {
    // ignore storage failures
  }
}

export function readHistory(): HistoryEntry[] {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (item): item is HistoryEntry =>
        item !== null &&
        typeof item === 'object' &&
        typeof item.id === 'string' &&
        typeof item.viewedAt === 'number',
    );
  } catch {
    return [];
  }
}

export function pushHistory(id: string) {
  try {
    const list = readHistory().filter((item) => item.id !== id);
    list.unshift({ id, viewedAt: Date.now() });
    localStorage.setItem(HISTORY_KEY, JSON.stringify(list.slice(0, 12)));
  } catch {
    // ignore storage failures
  }
}

export function formatViewedAt(ts: number): string {
  const diff = Date.now() - ts;
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  if (diff < minute) return '刚刚浏览';
  if (diff < hour) return `${Math.floor(diff / minute)} 分钟前`;
  if (diff < day) return `${Math.floor(diff / hour)} 小时前`;
  if (diff < day * 7) return `${Math.floor(diff / day)} 天前`;
  return new Date(ts).toLocaleDateString('zh-CN');
}